import { useCollectKycDataMachine } from '../components/machine-provider';

export default useCollectKycDataMachine;
export type ReturnOfCollectKycDataMachine = ReturnType<typeof useCollectKycDataMachine>;
